"use client";

import { useMemo } from "react";
import { api } from "@/api";
import useSWR from "swr";
import getEndpoint from "@/api/endpoints";

export interface OverwriteObject {
  [sectionKey: string]: {
    [fieldName: string]: string;
  };
}

export interface ModuleOverwritesResponse {
  type: string;
  message: string;
  overwriteObject: OverwriteObject;
}

// Keep overwrites as-is from backend (no transformation needed)
// The transformation will happen when matching section keys to overwrite keys

const useModuleOverwrites = (projectId: string, moduleSlug: string, page: string) => {
  const endpoint = useMemo(() => {
    if (!projectId || !moduleSlug || !page) return null;
    return getEndpoint("moduleOverwrites", { projectId, module: moduleSlug, page });
  }, [projectId, moduleSlug, page]);

  const { data, error, isLoading, mutate } = useSWR<ModuleOverwritesResponse>(
    endpoint ? `overwrites-${projectId}-${moduleSlug}-${page}` : null,
    async () => {
      if (!endpoint) return null;
      const res = await api.get(endpoint);
      return res.data;
    },
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      dedupingInterval: 5000,
    }
  );

  const overwrites = useMemo(() => {
    if (!data?.overwriteObject) return {};

    // Return overwrites as-is from backend
    console.log("Overwrites from backend:", data.overwriteObject);

    return data.overwriteObject;
  }, [data]);

  return {
    overwrites,
    isLoading,
    error,
    mutate,
  };
};

export default useModuleOverwrites;
